import React from "react";
import { ContratosProvider } from "./context/contratos-context";
import { Contratos } from "./contratos";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const ContratosFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Contratos"}>
            <ContratosProvider>
                <Contratos />
            </ContratosProvider>
        </BaseInternalFormFactory>
    );
};

export default ContratosFactory;
